import ApiService from "../../../../service/api/ApiService";
import ShowToast from "../../../../widget/common/ui/Toast";
import ApiUrls from "../../../../service/api/ApiUrls";
import CacheStorage from "../../../../service/storage/CacheStorage";
import StorageKeys from "../../../../const/StorageKeys";
import {
  ConversationSearchProfileList,
  ForwardProfileListModel,
} from "../../../../model/chats/ForwardProfileListModel";

const ForwardChatProvider = new (class ForwardChatProvider {
  getForwardProfilesAPI =
    async (): Promise<Array<ConversationSearchProfileList> | null> => {
      ApiUrls.init();

      const accountId: string = CacheStorage.getValue(StorageKeys.account_id);

      const url: string = `${ApiUrls.baseUrl}conversation/get_conversation_profile_list`;
      const body: any = {
        account_id: accountId,
      };

      const response: any = await ApiService.postApi(url, body);
      console.log(response);
      if (response != null) {
        if (response["success"] === "1") {
          const forwardProfileListModel: ForwardProfileListModel = response;
          const conversationSearchProfileList: Array<ConversationSearchProfileList> =
            forwardProfileListModel?.result?.conversation_search_profile_list!;

          return conversationSearchProfileList;
        } else {
          ShowToast.error(response["errorMessage"]);
        }
      }

      return null;
    };
})();

export default ForwardChatProvider;
